<template>
  <div class="d-flex align-center primary darken-1" style="height:38px;border-radius:30px">
    <v-menu offset-y
      v-model="config.search.type">
      <template v-slot:activator="{ on }">
        <v-btn fab text small
          v-on="on">
          <v-icon small v-if="getSearchType === 'box'">fa-cloud</v-icon>
          <v-icon small v-else-if="getSearchType === 'posts'">fa-clock</v-icon>
        </v-btn>
      </template>
      <v-list dense class="py-0">
        <v-list-item :class="getSearchType === 'box' ? 'primary lighten-4 primary--text' : ''" @click="setSearchType('box')">
          <v-list-item-avatar><v-icon small :class="getSearchType === 'box' ? 'primary--text' : ''">fal fa-cloud</v-icon></v-list-item-avatar>
          <v-list-item-content :class="getSearchType === 'box' ? 'primary--text text--darken-1' : ''">ライブラリの検索</v-list-item-content>
        </v-list-item>
        <v-list-item :class="getSearchType === 'posts' ? 'primary lighten-4' : ''" @click="setSearchType('posts')">
          <v-list-item-avatar><v-icon small :class="getSearchType === 'posts' ? 'primary--text' : ''">fal fa-clock</v-icon></v-list-item-avatar>
          <v-list-item-content :class="getSearchType === 'posts' ? 'primary--text text--darken-1' : ''">対応履歴の検索</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-if="getSearchType === 'box'" class="d-flex align-center" style="width:100%;">
      <v-menu
        v-model="config.datepickers.box.dates"
        :close-on-content-click="false"
        max-width="290">
        <template v-slot:activator="{ on }">
          <v-btn fab text small
            v-on="on"
            @click="form.box.dates = []">
            <v-badge left overlap
              :content="printBoxFilterDates"
              :color="printBoxFilterDates ? 'red' : 'transparent'">
              <v-icon small>fal fa-calendar-alt</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-date-picker range no-title
          v-model="form.box.dates"
          locale="ja"
          color="amber"
          :day-format="date => new Date(date).getUTCDate()"
        />
      </v-menu>
      <v-autocomplete solo flat open-on-clear hide-details
        ref="searcher"
        v-model="form.box.id"
        background-color="transparent"
        color="blue-grey darken-4"
        label="ライブラリの検索"
        item-text="name"
        item-value="id"
        :no-data-text="printBoxNoDataText"
        :items="getBoxItems"
        :loading="isSearching"
        :search-input.sync="form.box.search"
        @keypress.enter.prevent="search('box')"
        @change="open({ type: 'box', item: { id: form.box.id } })">
        <template v-slot:item="data">
          <v-list-item-avatar>
            <v-icon size="20" :class="`${data.item.icon.color}`">{{ `${data.item.icon.icon}` }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="body-2">
            <v-list-item-subtitle class="caption">{{ data.item.client ? data.item.client.name.replace(',', ' ') : '' }}</v-list-item-subtitle>
            <v-list-item-title>{{ data.item.name }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="mr-2">
            <v-btn icon
              color="secondary"
              @click="open({ type: 'client', item: data.item.client })">
              <v-icon small>fal fa-user</v-icon>
            </v-btn>
          </v-list-item-action>
        </template>
      </v-autocomplete>
      <PreviewModal ref="previewer" />
    </div>
    <div v-else-if="getSearchType === 'posts'" class="d-flex align-center" style="width:100%;">
      <v-menu
        v-model="config.datepickers.posts.dates"
        :close-on-content-click="false"
        max-width="290">
        <template v-slot:activator="{ on }">
          <v-btn fab text small
            v-on="on"
            @click="form.posts.dates = []">
            <v-badge left overlap
              :content="printPostsFilterDates"
              :color="printPostsFilterDates ? 'red' : 'transparent'">
              <v-icon small>fal fa-calendar-alt</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-date-picker range no-title
          v-model="form.posts.dates"
          locale="ja"
          color="amber"
          :day-format="date => new Date(date).getUTCDate()"
        />
      </v-menu>
      <v-autocomplete solo flat open-on-clear hide-details
        ref="searcher"
        v-model="form.posts.id"
        background-color="transparent"
        color="blue-grey darken-4"
        label="対応履歴の検索"
        item-text="content"
        item-value="id"
        :no-data-text="printPostsNoDataText"
        :items="getPostsItems"
        :loading="isSearching"
        :search-input.sync="form.posts.search"
        @keypress.enter.prevent="search('posts')"
        @change="open({ type: 'posts', item: { id: form.posts.id } })">
        <template v-slot:item="data">
          <v-list-item-avatar>
            <v-icon size="20" v-if="data.item.type === 'record'">fal fa-clipboard</v-icon>
            <v-icon size="20" v-else-if="data.item.type === 'tutor'">fal fa-chalkboard-teacher</v-icon>
            <v-icon size="20" v-else-if="data.item.type === 'credit'">fal fa-credit-card</v-icon>
            <v-icon size="20" v-else-if="data.item.type === 'transfer'">fal fa-envelope-open-dollar</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="body-2">
            <v-list-item-subtitle class="caption">{{ `${data.item.client ? data.item.client.name.replace(',', ' ') : ''}：${$moment(data.item.date).format('YYYY/MM/DD') || ''}：${data.item.title || 'タイトル無し'}` }}</v-list-item-subtitle>
            <v-list-item-title>{{ data.item.content }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import PreviewModal from '@/components/filers/components/modals/preview'
export default {
  name: 'auth-toolkit-search',
  components: {
    PreviewModal
  },
  data () {
    return {
      config: {
        status: {
          searching: false
        },
        datepickers: {
          box: {
            dates: false
          },
          posts: {
            dates: false
          }
        },
        search: {
          type: false
        }
      },
      meta: {
        searches: {
          box: {
            text: 'ファイル',
            value: 'box'
          },
          posts: {
            text: '対応履歴',
            value: 'post'
          }
        }
      },
      store: {
        type: 'box',
        box: {
          items: []
        },
        posts: {
          items: []
        },
        clients: [],
        files: []
      },
      form: {
        box: {
          search: '',
          dates: [],
          id: ''
        },
        posts: {
          search: '',
          dates: [],
          id: ''
        }
      }
    }
  },
  methods: {
    open: function (req) {
      const { type, item } = req
      if (type === 'client') {
        const resolve = this.$router.resolve({ path: `../client/${item.id}/box` })
        window.open(resolve.href, '_blank')
      } else if (type === 'box') {
        const idx = this.store.box.items.findIndex(it => { return it.id === item.id })
        if (idx >= 0) {
          this.$refs.previewer.open(this.store.box.items[idx])
        }
      } else if (type === 'posts') {
        const idx = this.store.posts.items.findIndex(it => { return it.id === item.id })
        if (idx >= 0) {
          const resolve = this.$router.resolve({ path: `../client/${this.store.posts.items[idx].client.id}/records`, query: { query: this.form.posts.search } })
          window.open(resolve.href, '_blank')
        }
      }
    },
    search: _.debounce(function (type, val) {
      this.submit({ type })
    }, 300),
    preSubmit: function (req) {
      const { type } = req || {}
      const { box, posts } = this.form
      const urls = {
        client: `${this.$url.api}client/get/items`,
        box: `${this.$url.api}box/search/${this.$mango.box.clients}`,
        posts: `${this.$url.api}posts/search`
      }
      const fds = {
        box: { name: box.search, types: ['file'], dates: box.dates },
        posts: { name: posts.search, dates: posts.dates }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'box' && box.search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'posts' && posts.search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'box') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store.box, 'items', data.entries)
      } else if (type === 'posts') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store.posts, 'items', data)
      }
    },
    failSubmit: function () {
      this.$set(this.config.status, 'loading', false)
      this.$set(this.config.status, 'searching', false)
    },
    setSearchType: function (type) {
      this.$set(this.store, 'type', type)
    }
  },
  watch: {
    'form.box.search': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store.box, 'items', [])
      }
      if (!this.config.status.searching) {
        this.search('box')
      }
    },
    'form.posts.search': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store.posts, 'items', [])
      }
      if (!this.config.status.searching) {
        this.search('posts')
      }
    }
  },
  computed: {
    isSearching () {
      return this.config.status.searching
    },
    printBoxNoDataText () {
      return this.form.box.search ? '検索結果0件です' : 'ファイル名を入力してください'
    },
    printPostsNoDataText () {
      return this.form.posts.search ? '検索結果0件です' : '件名・内容を入力してください'
    },
    printBoxFilterDates () {
      const [ dateA, dateB ] = this.form.box.dates
      if (this.form.box.dates.length === 2) {
        if (this.$moment(dateA).isBefore(dateB)) {
          return `${this.$moment(dateA).format('YY.MM.DD')} ~ ${this.$moment(dateB).format('YY.MM.DD')}`
        } else {
          return `${this.$moment(dateB).format('YY.MM.DD')} ~ ${this.$moment(dateA).format('YY.MM.DD')}`
        }
      } else if (this.form.box.dates.length === 1) {
          return `${this.$moment(dateA).format('YY.MM.DD')}`
      } else {
        return ''
      }
    },
    printPostsFilterDates () {
      const [ dateA, dateB ] = this.form.posts.dates
      if (this.form.posts.dates.length === 2) {
        if (this.$moment(dateA).isBefore(dateB)) {
          return `${this.$moment(dateA).format('YY.MM.DD')} ~ ${this.$moment(dateB).format('YY.MM.DD')}`
        } else {
          return `${this.$moment(dateB).format('YY.MM.DD')} ~ ${this.$moment(dateA).format('YY.MM.DD')}`
        }
      } else if (this.form.posts.dates.length === 1) {
          return `${this.$moment(dateA).format('YY.MM.DD')}`
      } else {
        return ''
      }
    },
    getSearchType () {
      return this.store.type
    },
    getSearchTypeItems () {
      return Object.keys(this.meta.searches).map(key => {
        return this.meta.searches[key]
      })
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return {
          text: `${it.name.replace(',', '')}（${it.kana.replace(',', '')}）`,
          value: it.id
        }
      }) : []
    },
    getBoxItems () {
      return this.store.box.items.length ? this.store.box.items.map(it => {
        const { extension } = it
        return Object.assign(it, { icon: this.$mango.files[extension ? extension.toUpperCase() : 'FILE'] || this.$mango.files.FILE })
      }) : []
    },
    getPostsItems () {
      return this.store.posts.items.length ? this.store.posts.items.map(it => {
        const isObj = ['tutor', 'credit', 'transfer'].includes(it.type || '')
        const { type, content } = {
          type: it.type,
          content: isObj ? JSON.parse(it.content) : it.content
        }
        return Object.assign(it, {
          content: isObj ? Object.keys(content).map(key => { return content[key] }).join(', ') : content
        })
      }) : []
    }
  }
}
</script>